import React from "react";

import Header from "../../components/Header";
import { Card } from 'primereact/card';
import { Button } from "primereact/button";

import "./styles.css";

import { AppConfig } from "../../App.config.js";
import {Context} from "../../AppProvider";


function TelaLogin() {
  return (
    <Context.Consumer>
      {(context) => (
        <div className="login">
          <Header usuario={context.usuario} />
          {renderGoogleLogin(context.usuario)}
          {renderUsuarioNaoAutorizado(context.usuario)}
        </div>
      )}
    </Context.Consumer>
  );
}

function decidirFrontendHost() {
  return AppConfig.GAS_URL_ACCOUNT_CHOOSER += (AppConfig.DEV_MODE)?  AppConfig.GAS_URL_DEV : AppConfig.GAS_URL_EXEC;
}


/**
 * @description - Aplica a ação de carregar a URL de login Google, concatenada com a do script web em modo dev, caso o usuário
 * não esteja logado e autorizado. 
 * @param {*} usuario 
 */
function renderGoogleLogin(usuario) {
  if (usuario && !usuario.email && !usuario.autorizado) {
    window.location.replace(decidirFrontendHost());
  }
}

/**
 * @description - Renderiza um botão para abertura de uma nova aba/janela para autenticação noutra conta, caso o usuário
 * não esteja logado mas não esteja autorizado (ex.: como participante de avaliações ou gerente do aplicativo).
 * @param {*} usuario 
 */
function renderUsuarioNaoAutorizado(usuario) {
  if (usuario && usuario.email && !usuario.autorizado) {
    let titulo = (
      <div>
        ACESSO DESAUTORIZADO!
      </div>
    );

    let subtitulo = (
      <div>
        Acesso desautorizado para a conta <b>{usuario.email}</b>.
      </div>
    );

    return (
      <Card className="p-col p-mb-2"
        title={titulo}
        subTitle={subtitulo}
      >
        <div className="p-d-flex p-jc-center">
          <div className="p-col-6 p-ml-2 p-mb-1">
            <p className="p-mb-2">Faça login numa conta autorizada.</p>
            <p className="p-mb-2">Se a sua conta é a correta, tente um novo acesso numa aba anônima para este aplicativo, usando o endereço <b>http://{window.location.hostname}</b></p>
            <p className="p-mb-2">Se o problema persistir, contate a CPA pelo e-mail <b>{AppConfig.CPA_EMAIL}</b> reportando o problema.</p>
          </div>
          <div className="p-col-5 p-ml-2">
            <Button className="p-button-lg"
              label="FAZER LOGIN NOUTRA CONTA"
              icon="pi pi-google"
              onClick={() => { 
                window.open(decidirFrontendHost(), '_blank', 'noopener,noreferrer');
              }} />
          </div>
        </div>

      </Card>
    );
  }

}

export default TelaLogin;
